import React from 'react';

import { configs } from '@hero/configs';

import ProductDetailByCheckbox from './ProductDetailByCheckbox';
import ProductDetailByTable from './ProductDetailByTable';

const componentNameByVariant = {
  default: ProductDetailByCheckbox,
  table: ProductDetailByTable
};

export function ProductDetail(props) {
  const variant = configs.productDetail?.variant || 'default';

  const LazyComponent = componentNameByVariant[variant];

  return <LazyComponent {...props} />;
}
